module.exports = __webpack_public_path__ + "static/javavisuals-23ca0476c7fdca3ba82bc29b7eeac8d0.gif";